import { render, staticRenderFns } from "./RegimeDeBens.vue?vue&type=template&id=1992aae3&"
import script from "./RegimeDeBens.vue?vue&type=script&lang=js&"
export * from "./RegimeDeBens.vue?vue&type=script&lang=js&"
import style0 from "./RegimeDeBens.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports